"use client";

import { useEffect } from "react";
import {
  buildExamThemeCookie,
  EXAM_THEME_COOKIE,
} from "@/components/exams/exam-theme/exam-theme";

/**
 * Utrzymuje klasę `dark` na <html> przez cały czas, gdy user jest w sekcji egzaminów, i zdejmuje ją
 * przy wyjściu.
 *
 * Klasa siedzi na <html>, a nie na kontenerze sekcji, i to JEDYNE źródło prawdy o motywie (poza samym
 * ciasteczkiem). Wcześniej klasę renderował też serwerowy layout na własnym divie - i to był błąd:
 * div z klasą pochodził z odpowiedzi serwera, więc przełącznik nie mógł go zdjąć bez ponownego renderu,
 * a przemapowanie palety działa na potomkach. Efekt: motyw dawał się włączyć i już nie dawał wyłączyć.
 *
 * <html> ma jeszcze tę zaletę, że obejmuje portale (Popover, Dialog, Select, Toaster), które renderują
 * się przy <body>, poza drzewem sekcji.
 */
export const ExamThemeSync = ({
  cookieName = EXAM_THEME_COOKIE,
  systemDefault = false,
}: {
  cookieName?: string;
  /** Bez ciasteczka bierzemy motyw przeglądarki i zapisujemy go — dalej obowiązuje wybór usera. */
  systemDefault?: boolean;
}) => {
  useEffect(() => {
    const root = document.documentElement;
    const entries = document.cookie.split(";").map((entry) => entry.trim());
    let isDark = entries.includes(`${cookieName}=dark`);

    if (systemDefault && !isDark && !entries.includes(`${cookieName}=light`)) {
      isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
      document.cookie = buildExamThemeCookie(isDark, cookieName);
    }

    // Przy wejściu z nawigacji klienta skrypt wstępny z layoutu się nie wykonuje, więc stan z ciasteczka
    // dociągamy tutaj. Przy twardym wejściu klasa już jest i to przypisanie nic nie zmienia.
    root.classList.toggle("dark", isDark);
    root.style.colorScheme = isDark ? "dark" : "";

    return () => {
      root.classList.remove("dark");
      root.style.colorScheme = "";
    };
  }, [cookieName, systemDefault]);

  return null;
};
